import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';

import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Datenschutz from './components/Datenschutz';
import Impressum from './components/Impressum';
import ScrollToTop from './components/ScrollToTop';
import AGB from './components/AGB';

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Header />

      <Routes>
        <Route
          path="/"
          element={
            <main>
              <Hero />
              <Services />
              <About />
              <Contact />
            </main>
          }
        />
        <Route path="/datenschutz" element={<Datenschutz />} />
        <Route path="/impressum" element={<Impressum />} /><Route path="/agb" element={<AGB />} />
        
      </Routes>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;